import { motion } from "framer-motion";

const REVIEWS = [
  {
    name: "Arjun Aggarwal",
    role: "Full Stack Developer",
    quote:"Working at Valsco Tech has been a very hands on and growth oriented experience. The team focuses heavily on building clean, reliable solutions rather than just rushing features. There’s a strong emphasis on writing good code and solving real client problems, which makes everyday work both challenging and enjoyable."  },
  {
    name: "Indresh Goswami",
    role: "Software Developer",
    quote:"At Valsco Tech, engineering is all about practicality and reliability. I get to work with modern technologies while collaborating closely with a supportive team. The strong culture of ownership really pushes you to do your best work. It’s satisfying to build systems that clients can trust and depend on"  },
  {
    name: "Rohan Shirvastava",
    role: "Sales & Marketing ",
    quote:"Being part of the sales and marketing team at Valsco Tech has been very fulfilling. Clients value our transparent communication and strong technical understanding, which builds long term trust. It feels great to represent a company that focuses on delivering reliable solutions and maintaining lasting partnerships rather than short term wins."  },
];

const container = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.12,
    },
  },
};

const item = {
  hidden: { opacity: 0, y: 30 },
  show: { opacity: 1, y: 0 },
};

const TeamReviews = () => {
  return (
    <section className="py-12 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-semibold text-gray-900">
            What Our Team Says
          </h2>
          <p className="mt-4 text-gray-500 max-w-xl mx-auto">
            Real people building Valsco every day
          </p>
        </div>

        {/* Cards */}
        <motion.div
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="grid grid-cols-1 md:grid-cols-3 gap-8"
        >
          {REVIEWS.map((review, index) => (
            <motion.div
              key={index}
              variants={item}
              className="rounded-2xl border border-gray-200 p-8 shadow-sm hover:shadow-md transition"
            >
              <p className="text-gray-700 leading-relaxed mb-6">
                “{review.quote}”
              </p>

              <div className="flex items-center gap-3">
                {/* Avatar */}
                <div className="w-10 h-10 rounded-full bg-gray-900 text-white flex items-center justify-center text-sm font-medium">
                  {review.role.charAt(0)}
                </div>

                <div>
                  <p className="text-sm font-medium text-gray-900">
                    {review.name}
                  </p>
                  <p className="text-xs text-gray-500">{review.role}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default TeamReviews;
